import React, { createContext, useContext, useMemo, useState } from 'react';
import type { ReactNode } from 'react';
export interface ContactLead {
  name: string;
  email: string;
  company: string;
  message: string;
}
export type BookingModalSource = 'blank' | 'prefill';
interface ContactBookingContextValue {
  lead: ContactLead | null;
  setLead: (lead: ContactLead) => void;
  isModalOpen: boolean;
  modalSource: BookingModalSource;
  openModal: (source: BookingModalSource) => void;
  closeModal: () => void;
  bookingConfirmed: boolean;
  confirmBooking: () => void;
}
const ContactBookingContext = createContext<ContactBookingContextValue | undefined>(undefined);
export function ContactBookingProvider({
  children
}: {
  children: ReactNode;
}) {
  const [lead, setLead] = useState<ContactLead | null>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalSource, setModalSource] = useState<BookingModalSource>('blank');
  const [bookingConfirmed, setBookingConfirmed] = useState(false);
  const value = useMemo<ContactBookingContextValue>(() => ({
    lead,
    setLead,
    isModalOpen,
    modalSource,
    openModal: source => {
      setModalSource(source);
      setIsModalOpen(true);
    },
    closeModal: () => setIsModalOpen(false),
    bookingConfirmed,
    confirmBooking: () => setBookingConfirmed(true)
  }), [lead, isModalOpen, modalSource, bookingConfirmed]);
  return <ContactBookingContext.Provider value={value} data-id="element-913" data-mp="1zgvv3v4h8eyn">{children}</ContactBookingContext.Provider>;
}
export function useContactBooking() {
  const context = useContext(ContactBookingContext);
  if (!context) {
    throw new Error('useContactBooking must be used within a ContactBookingProvider');
  }
  return context;
}